export const routeInfoLocaleDict = {
    ru: {
        fromPoint: 'Из точки',
        toPoint: 'в точку',
        distance: 'дистанция',
        time: 'время',
        totalDistance: 'Общая дистанция',
        totalTime: 'Общее время',
        vehicleUsage: 'Время использования ТС (мин)'
    },
    en: {
        fromPoint: 'From spot',
        toPoint: 'on spot',
        distance: 'distance',
        time: 'time',
        totalDistance: 'Total distance',
        totalTime: 'Total duration',
        vehicleUsage: 'Vehicle usage time (min)'
    },
    th: {
        fromPoint: 'จากจุด',
        toPoint: 'ตรงจุด',
        distance: 'ระยะทาง',
        time: 'เวลา',
        totalDistance: 'ระยะทางรวม',
        totalTime: 'ระยะเวลารวม',
        vehicleUsage: 'Vehicle usage time (นาที)'
    },
    tr: {
        fromPoint: 'Noktadan',
        toPoint: 'noktaya',
        distance: 'mesafe',
        time: 'süre',
        totalDistance: 'Toplam mesafe',
        totalTime: 'Toplam süre',
        vehicleUsage: 'Araç kullanım süresi (dk)'
    }
};
